module.exports = __webpack_public_path__ + "media/Components/fonts/OleoScript-858b876ed790463b32518e2dd6d6c6fc.ttf";